import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { SLIM_HEADER_CONVERTER_TOKEN, SlimHeaderConverter } from './slim-header.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        slimHeaderFeature: {
          module: () => import('./slim-header.module').then((m) => m.SlimHeaderModule),
          cmsComponents: ['slimheader'],
        },
      }
    }),
    {
      provide: SLIM_HEADER_CONVERTER_TOKEN,
      useExisting: SlimHeaderConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        slimheader: SLIM_HEADER_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class SlimHeaderFeatureModule {}
